"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntersectionObserver = require("react-intersection-observer");
var _Svg = _interopRequireDefault(require("./Svg"));
var _constants = require("../constants");
var DecorationGrid = function DecorationGrid(_ref) {
  var image1 = _ref.image1,
    image2 = _ref.image2,
    _ref$dotsFill = _ref.dotsFill,
    dotsFill = _ref$dotsFill === void 0 ? '#35b1fb' : _ref$dotsFill,
    _ref$squareFill = _ref.squareFill,
    squareFill = _ref$squareFill === void 0 ? '#3464b6' : _ref$squareFill;
  var _useInView = (0, _reactIntersectionObserver.useInView)({
      rootMargin: _constants.LAZY_LOAD_OFFSET,
      triggerOnce: true
    }),
    ref = _useInView.ref,
    inView = _useInView.inView;
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref,
    className: "d8-c-decoration-grid"
  }, /*#__PURE__*/_react["default"].createElement("div", null, inView && /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
    className: "dots-svg",
    name: "dots",
    fill: dotsFill
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "decoration-square",
    style: {
      backgroundColor: squareFill
    }
  }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("img", {
    className: "d8-u-radius-md",
    src: inView ? image1.url : '',
    alt: image1.alt
  })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("img", {
    className: "d8-u-radius-md",
    src: inView ? image2.url : '',
    alt: image2.alt
  })));
};
DecorationGrid.propTypes = {
  image1: _propTypes["default"].object,
  image2: _propTypes["default"].object,
  dotsFill: _propTypes["default"].string,
  squareFill: _propTypes["default"].string
};
var _default = exports["default"] = DecorationGrid;